import { snakeToCamel } from '@ben/orion/utils/converter';
import type { RJSFSchema } from '@rjsf/utils';
import { extractFileNameFromDataUrl, parseExistingFile } from '../utils';
import type { RJSFFile, SchemaFormValuesProps } from './types';

export const isHiddenByDependency = (
  { schema, data }: SchemaFormValuesProps,
  key: string
) => {
  if (!schema.dependencies) {
    return false;
  }
  const keyProperties = schema.properties?.[key] as RJSFSchema;
  const schemaDependencies = schema.dependencies as RJSFSchema;

  for (const dependencyKey of Object.keys(schemaDependencies)) {
    const activeDependency = schemaDependencies[dependencyKey]?.oneOf?.find(
      (dependency: RJSFSchema) => {
        const dependencyProperty = dependency.properties?.[dependencyKey] as
          | RJSFSchema
          | undefined;
        return dependencyProperty?.enum?.includes(data[dependencyKey]);
      }
    );
    // check if the active dependency is influencing the hidden prop of the current key and return if it is
    const deepHidden = activeDependency?.properties?.[key]?.properties?.hidden;
    if (typeof deepHidden === 'boolean') {
      return deepHidden;
    }
  }
  return keyProperties?.properties?.hidden ?? false;
};

export const getFile = (file?: string | RJSFFile) => {
  if (typeof file === 'string' && file.startsWith('data:text/url')) {
    return parseExistingFile(file);
  }
  if (typeof file === 'string') {
    return {
      file,
      originalName: extractFileNameFromDataUrl(file, 0),
    };
  }
  const { fileUrl, originalName, uuid } = snakeToCamel(file || {}) as {
    fileUrl?: string;
    originalName?: string;
    uuid?: string;
  };
  return {
    file: fileUrl ?? '',
    originalName: originalName ?? '',
    uuid,
  };
};

export const getPricingAmount = (
  pricingFormula?: string,
  employeeContribution?: number,
  isEmployee?: boolean
) => {
  const price = Number(pricingFormula);
  const contribution = employeeContribution ?? 0;
  const percentage = isEmployee ? contribution : 100 - contribution;
  return Number(((percentage * price) / 100).toFixed(2));
};
